import { useEffect } from "react";
import { useNavigate } from "react-router-dom"
import Leftnavbar from "../../sections/Leftnavbar";
import Topnavbar from "../../sections/Topnavbar";

const Welcome = () => {

   const navigate = useNavigate()   
   const renderizar = () => {
      const element = document.getElementsByTagName("body");
      if (element[0].classList.contains('sidebar-open')) {
         element[0].classList.remove('sidebar-open')
         element[0].classList.add('sidebar-closed')
         element[0].classList.add('sidebar-collapse')

      }
   }
   return (
      <>
         <Leftnavbar />
         <Topnavbar />
         <div className="content-wrapper">
            <div className="content-header">
               <div className="container-fluid">
                  <div className="row">
                     <div className="col text-center">
                        <h1 className="m-0">Bienvenido</h1>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   )
}

export default Welcome